import { Disclosure } from "@headlessui/react";
import { ChevronRight } from "@material-ui/icons";

const EmployeeNsaHierarchyLeadership = ({ leadership }) => {
  const DisplayRow = ({ label, value }) => (
    <div className="grid grid-cols-3 p-2">
      <label className="col-span-1 mx-4 expandedLabel fontExpand">
        {label}
      </label>
      <div className="col-span-2 expandedData fontExpand">{value}</div>
    </div>
  );

  const managersLabel = (type, target, label) =>
    type === target ? label : label;

  return (
    <>
      <Disclosure defaultOpen>
        {({ open }) => (
          <>
            <div className="mx-4 mb-2 bg-white rounded-lg box-shadow">
              <Disclosure.Button className="disclosureBtn ml-2">
                <ChevronRight
                  className={`${
                    open ? "transform rotate-90" : " text-gray-500"
                  } text-gray-500 w-5 h-5 `}
                />
                <span className="disclosureLabel ml-2">
                  Hierarchy and Leadership
                </span>
              </Disclosure.Button>

              <Disclosure.Panel>
                <div className="grid grid-cols-1 md:grid-cols-2 text-xs py-2">
                  {/* Left column */}
                  <div className="p-2 divide-y">
                    <DisplayRow label="Hierarchy Channel:" value="NSA" />
                    <DisplayRow
                      label="Hierarchy Leadership:"
                      value={leadership?.officeHierarchyType}
                    />
                    <DisplayRow
                      label="Reports To:"
                      value={leadership?.reportsToEmployeeName}
                    />
                    <DisplayRow
                      label={managersLabel(
                        leadership?.officeHierarchyType,
                        "District",
                        "District Manager:"
                      )}
                      value={leadership?.districtManager}
                    />
                    <DisplayRow
                      label={managersLabel(
                        leadership?.officeHierarchyType,
                        "Region (Market)",
                        "Region Manager:"
                      )}
                      value={leadership?.regionManager}
                    />
                    <DisplayRow
                      label={managersLabel(
                        leadership?.officeHierarchyType,
                        "Area",
                        "Area Manager:"
                      )}
                      value={leadership?.areaManager}
                    />
                    <DisplayRow
                      label={managersLabel(
                        leadership?.officeHierarchyType,
                        "Territory",
                        "Territory Manager:"
                      )}
                      value={leadership?.territoryManager}
                    />
                  </div>

                  {/* Right column */}
                  <div className="p-2 divide-y">
                    <DisplayRow
                      label="Reports To Status:"
                      value={leadership?.employeeStatus}
                    />
                    <DisplayRow
                      label="Reports To Term Date:"
                      value={
                        leadership?.terminationDate &&
                        new Date(
                          leadership?.terminationDate
                        ).toLocaleDateString()
                      }
                    />
                    <div className="min-h-[33px]">
                      <DisplayRow label="" value="" />
                    </div>
                    <DisplayRow
                      label="District Name:"
                      value={leadership?.districtNames}
                    />
                    <DisplayRow
                      label="Region Name:"
                      value={leadership?.regionNames}
                    />
                    <DisplayRow
                      label="Area Name:"
                      value={leadership?.areaNames}
                    />
                    <DisplayRow
                      label="Territory Name:"
                      value={leadership?.territoryNames}
                    />
                  </div>
                </div>
              </Disclosure.Panel>
            </div>
          </>
        )}
      </Disclosure>
    </>
  );
};
export default EmployeeNsaHierarchyLeadership;
